import Button from "@mui/material/Button";
import React from "react";
import { getOrPickVariant } from "../utils/abVariant";
import { canAccessFlowVersionB } from "../utils/flowVersionBAccess";
import VafFlow from "../vafFlow/vafFlow";
import VafFlowVersionB from "../vafFlowVersionB/vafFlow";

export default function VafFlowABEntry() {
  // Real 5%-of-visitors A/B roll (sticky cookie) — vafFlowVersionB is now live for real traffic.
  const variant = React.useMemo(() => getOrPickVariant("vafflow"), []);

  const [useVersionB, setUseVersionB] = React.useState(false);
  const canSwitchToVersionB = canAccessFlowVersionB();
  const shouldShowVersionB = variant === "B" || useVersionB;

  return (
    <>
      {canSwitchToVersionB && !shouldShowVersionB && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => setUseVersionB(true)}
          sx={{ mb: 2 }}
        >
          Open VafFlow B
        </Button>
      )}
      {shouldShowVersionB ? <VafFlowVersionB /> : <VafFlow />}
    </>
  );
}
